import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Select2 } from 'libs/form';
import { Place } from './parkomats-select.styled';

export const ParkomatsSelect = (props) => {
  const { value, onChange, parkingId, racks, label } = props;
  const { t } = useTranslation();

  /**
   * get parkomats list
   * @returns [option]
   */
  const getParkomats = () => {
    return racks.filter((el) => {
      if (window.config.central && !parkingId) {
        return el.parking_id === value;
      }
      return true;
    });
  };

  /**
   * change
   * @param {*} e
   */
  const change = (e) => {
    onChange(e.target.value);
  };

  const parkomats = getParkomats();
  const parkomatsList = parkomats.map((el) => ({ value: el.id, name: el.mapped_name }));
  const title = label ? label : t('form.Устройство');

  return (
    <Place>
      <label htmlFor="parkomat-select">{title}</label>
      <Select2 id="parkomat-select" onChange={change} value={value} items={parkomatsList} />
    </Place>
  );
};

ParkomatsSelect.propTypes = {
  parkingId: PropTypes.any,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.any.isRequired,
  racks: PropTypes.any.isRequired,
  label: PropTypes.any,
};
